import { render, staticRenderFns } from "./FreeReport.vue?vue&type=template&id=036ef044&scoped=true&"
import script from "./FreeReport.vue?vue&type=script&lang=js&"
export * from "./FreeReport.vue?vue&type=script&lang=js&"
import style0 from "./FreeReport.vue?vue&type=style&index=0&id=036ef044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ef044",
  null
  
)

export default component.exports